// language=GraphQL
export const ALL_MAILCHIMP_CONFIGS_QUERY = `query Query {
  mailchimpConfigs: mailchimpConfigs {
    id
    apiKey
    serverPrefix
    listId
  }
}`

// language=GraphQL
export const SINGLE_MAILCHIMP_CONFIG_QUERY = `query Query($id: ID!) {
  mailchimpConfig: mailchimpConfig(id: $id) {
    id
    apiKey
    serverPrefix
    listId
  }
}`

// language=GraphQL
export const CREATE_MAILCHIMP_CONFIG_MUTATION = `
  mutation Mutation($input: CreateMailchimpConfigInput) {
    mailchimpConfig: createMailchimpConfig(input: $input) {
      id
      apiKey
      serverPrefix
      listId
    }
  }`

// language=GraphQL
export const UPDATE_MAILCHIMP_CONFIG_MUTATION = `
  mutation Mutation($input: UpdateMailchimpConfigInput) {
    mailchimpConfig: updateMailchimpConfig(input: $input) {
      id
      apiKey
      serverPrefix
      listId
    }
  }`

// language=GraphQL
export const DELETE_MAILCHIMP_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteMailchimpConfigInput) {
    deleteMailchimpConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_MAILCHIMP_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteMailchimpConfigInput) {
    forceDeleteMailchimpConfig(input: $input) {
      success
    }
  }`
// language=GraphQL
export const MAILCHIMP_CONFIGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withNewsletterProviders: Boolean = false) {
  groupedDependents: mailchimpConfigDependents(id: $id) {
    newsletterProviders @include(if: $withNewsletterProviders) {
      id
      provider
    }
  }
}`
